import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({
  baseURL: `${backendUrl}/api/v1/client`,
  withCredentials: true,
  xsrfCookieName: 'csrf_token',
  xsrfHeaderName: 'X-CSRF-Token',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
});

let memoryCsrfToken = null;

/**
 * Explicitly fetch CSRF token from backend
 */
export const fetchCsrfToken = async () => {
  try {
    const backendBase = process.env.REACT_APP_BACKEND_URL || '';
    const response = await axios.get(`${backendBase}/api/v1/csrf-token`, { withCredentials: true });
    if (response.data && response.data.csrfToken) {
      memoryCsrfToken = response.data.csrfToken;
    }
  } catch (error) {
    console.error('Failed to fetch CSRF token:', error);
  }
};

// Add a request interceptor for potential debugging or header injection
api.interceptors.request.use(
  (config) => {
    // 1. First try to use the token we got from the JSON payload (safest for cross-domain prod)
    if (memoryCsrfToken) {
      config.headers['X-CSRF-Token'] = memoryCsrfToken;
    } 
    // 2. Fallback: Manually extract csrf_token from cookie
    else if (typeof document !== 'undefined') {
      const cookies = document.cookie.split(';');
      const csrfCookie = cookies.find(c => c.trim().startsWith('csrf_token='));
      if (csrfCookie) {
        const token = csrfCookie.split('=')[1];
        if (token) {
          config.headers['X-CSRF-Token'] = token;
        }
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle global errors (like 401 Unauthorized)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Clear local user state if session expired
      // This is often handled by AuthContext, but can be triggered here
      console.warn('Session expired or unauthorized');
    }
    return Promise.reject(error);
  }
);

export default api;
